// eslint-disable-next-line import/prefer-default-export
export { default as ComparisonsLink } from "./comparisons-link";
export { default as ComparisonsLinks } from "./comparisons-links";
